export enum EnumMomentoBaixaEstoque {
  Venda = 'venda',
  Producao = 'producao'
}
